import { ParsedQs } from "qs";

type AppliedFilters = Record<string, string | string[] | undefined>;

export interface FilterValues {
  selectedCategories: string[] | null;
  selectedFulfillments: string[] | null;
}

export const extractFilterValues = (parsedQs: ParsedQs): FilterValues => {
  const appliedFilters = getAppliedFilters(parsedQs);

  const selectedCategories = appliedFilters.category
    ? Array.isArray(appliedFilters.category)
      ? (appliedFilters.category as string[])
      : [appliedFilters.category]
    : null;

  const selectedFulfillments = parsedQs.fulfillment
    ? Array.isArray(parsedQs.fulfillment)
      ? (parsedQs.fulfillment as string[])
      : [parsedQs.fulfillment as string]
    : null;

  return {
    selectedCategories,
    selectedFulfillments,
  };
};

export const countAppliedFilters = (parsedQs: ParsedQs): number => {
  const appliedFilters = getAppliedFilters(parsedQs);

  return Object.values(appliedFilters).reduce((count, value) => {
    if (!value) {
      return count;
    }

    if (Array.isArray(value)) {
      const validValues = value.filter((v) => v && v.trim() !== "");
      return count + validValues.length;
    }

    return value.trim() === "" ? count : count + 1;
  }, 0);
};

export const appliedFilterSections = (parsedQs: ParsedQs): string[] => {
  const appliedFilters = getAppliedFilters(parsedQs);
  return Object.keys(appliedFilters);
};

const getAppliedFilters = (parsedQs: ParsedQs): AppliedFilters => {
  return (parsedQs.filter as AppliedFilters) || {};
};
